import qs from 'qs'

import splitUrl from '@shared/lib/utils/splitUrl'

import type { FormValues } from '../../schema'
import type { TracingUrlDialogProps } from '../../TracingUrlDialog'

const mapInitialValues = (data: TracingUrlDialogProps['data']): FormValues => {
  if (!data) {
    return {
      name: '',
      url: '',
      utmCampaignId: '',
      utmCampaignSource: '',
      utmCampaignMedium: '',
      utmCampaignName: '',
      utmCampaignTerm: '',
      utmCampaignContent: '',
    }
  }

  /**
   * 取出 url 中 utm 相關 query string 的值。
   * `#fragment` 要先剝離、最後接回 url 欄位結尾 —— 否則錨點會被黏進最後一個
   * 參數值（如 utm_content），再次儲存時被編碼成 %23 而失效。
   */
  const { origin: originUrl, query: querystring, hash } = splitUrl(data.url)

  const {
    utm_campaign_id = '',
    utm_source = '',
    utm_medium = '',
    utm_campaign = '',
    utm_term = '',
    utm_content = '',
    ...otherQuerystring
  } = qs.parse(querystring)

  const url =
    [originUrl, qs.stringify(otherQuerystring)].filter(Boolean).join('?') + hash

  return {
    name: data.name,
    url,
    utmCampaignId: utm_campaign_id as string,
    utmCampaignSource: utm_source as string,
    utmCampaignMedium: utm_medium as string,
    utmCampaignName: utm_campaign as string,
    utmCampaignTerm: utm_term as string,
    utmCampaignContent: utm_content as string,
  }
}

export default mapInitialValues
